import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { Box } from "@mui/material";
import { RowSailorType } from "@/types/view";
import { AppConstant, LangConstant } from "@/const";
import { StatusInternalRequest } from "@/components/common";
import { GridColDef } from "@/components/common/AppTable/AppTable";
import { Fragment } from "react";
import { SOURCE_TYPE } from "@/const/system.const";

const useIdSearchColumn = () => {
  const { t: getLabel } = useTranslation(LangConstant.NS_REQUEST);

  const columnList: GridColDef<RowSailorType>[] = [
    {
      field: "uid",
      headerName: getLabel("OBJ_SAILOR_COL.code"),
      align: "left",
    },
    {
      field: "fullName",
      headerName: getLabel("OBJ_SAILOR_COL.name"),
      align: "center",
    },
    {
      field: "identification",
      headerName: getLabel("OBJ_SAILOR_COL.identity"),
      align: "center",
    },
    {
      field: "created",
      headerName: getLabel("OBJ_SAILOR_COL.responseAt"),
      align: "center",
      render: (cell: RowSailorType) => {
        return (
          cell.created && (
            <Box>
              {dayjs(cell.created).format(AppConstant.FM_SHORT_DATE)}
              <br />
              {dayjs(cell.created).format(AppConstant.FM_FULL_HOUR)}
            </Box>
          )
        );
      },
    },
    {
      field: "sourceType",
      headerName: getLabel("OBJ_SAILOR_COL.source"),
      align: "center",
      render: (cell: RowSailorType) => {
        return Object.values(SOURCE_TYPE).find(item => item.id == cell.sourceType)?.name;
      },
    },
    {
      field: "status",
      headerName: getLabel("OBJ_SAILOR_COL.status"),
      align: "center",
      render: (cell: RowSailorType) => (
        <Fragment>
          <StatusInternalRequest status={cell.status} />
        </Fragment>
      ),
    },
  ];

  return {
    columnList,
  };
};

export default useIdSearchColumn;
